module.exports = __webpack_public_path__ + "static/customer_photo_1-17eb091e3d0211ee7df1c57a05d92aa5.jpg";